import React from "react"

function Footer() {
    return (
        <>
            <footer className="footer">&copy; Copyright 2020 Carlos J Benitez</footer></>
    )
}

export default Footer